import styled from 'styled-components';
import { Button } from '~/components/Button';

export const ButtonSmall = styled(Button)`
  min-height: 2rem;
  padding: 0 0.5rem;
`;
try {
    // @ts-ignore
    ButtonSmall.displayName = "ButtonSmall";
    // @ts-ignore
    ButtonSmall.__docgenInfo = { "description": "", "displayName": "ButtonSmall", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/ButtonSmall/ButtonSmall.tsx#ButtonSmall"] = { docgenInfo: ButtonSmall.__docgenInfo, name: "ButtonSmall", path: "src/components/ButtonSmall/ButtonSmall.tsx#ButtonSmall" };
}
catch (__react_docgen_typescript_loader_error) { }